import { Logger } from 'emrn-hybrid/Logger';
import { Router } from 'emrn-hybrid/Router';
import { isEastmoneyApp } from 'emrn-hybrid/isEastmoneyApp';

/**
 * 打开广告配置链接
 * @param url 地址
 */
export const openUrl = (url: string) => {
  Logger.info({ tag: '金融挑战赛', msg: `即将打开广告链接：${url}` });
  if (!url) {
    return;
  }

  if (/^http/i.test(url)) {
    if (isEastmoneyApp) {
      Router.openH5({ url });
    } else {
      window.open(url, 'blank');
      //location.href = url;
    }
    return;
  }

  Router.openDeepLink({ deepLink: url });
};
